import React from 'react';

export const FinalCTASection = ({ 
  imageUrl, 
  headline, 
  description, 
  primaryButtonText = "Consult Now", 
  primaryButtonLink = "#", 
  secondaryButtonText = "Book Appointment", 
  secondaryButtonLink = "#" 
}) => {
  return (
    <section className="py-20" style={{ backgroundColor: '#FFFDFB' }}>
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10" data-testid="final-cta-section">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {imageUrl && (
            <div className="relative aspect-[4/3] overflow-hidden rounded-xl">
              <img src={imageUrl} alt="Get consultation and book appointment" className="w-full h-full object-cover" loading="lazy" width="800" height="600" />
            </div>
          )}

          <div className="text-center lg:text-left">
            {headline && <h2 className="text-[1.8rem] text-center md:text-3xl lg:text-4xl md:text-center lg:text-left text-[#00224F] mb-4 leading-tight" style={{ fontWeight: 750 }} dangerouslySetInnerHTML={{ __html: headline }}></h2>}
            {description && <div className="text-[#5A6978] mb-8 text-base md:text-lg leading-relaxed" dangerouslySetInnerHTML={{ __html: description }}></div>}

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={primaryButtonLink}
                className="flex-1 h-16 md:h-12 px-6 rounded-lg transition-colors inline-flex items-center justify-center"
                style={{ backgroundColor: 'rgb(242, 201, 0)', color: '#00224F', fontWeight: 600 }}
                data-testid="consult-now-button"
              >
                {primaryButtonText}
              </a>
              <a
                href={secondaryButtonLink}
                className="flex-1 h-16 md:h-12 px-6 rounded-lg bg-white border-2 border-[#00224F] text-[#00224F] hover:bg-[#00224F] hover:text-white font-medium transition-colors inline-flex items-center justify-center"
                data-testid="book-appointment-button"
              >
                {secondaryButtonText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
